import { render, staticRenderFns } from "./AccountsFileGridComponent.vue?vue&type=template&id=1f9981f4"
import script from "./AccountsFileGridComponent.vue?vue&type=script&lang=js"
export * from "./AccountsFileGridComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports